"use client"

import { pushToDataLayer } from "@/helpers/gtag";
import styles from "./NewsCard.module.scss";
import cn from "clsx";
import { getGlobalStateValue } from "@/context/utils";
import {imgPathReplace} from '@/helpers/imgPathReplace';
import dayjs from "dayjs";

export default function NewsCard({
  Heading,
  url_key,
  NewsProvider,
  FeaturedImage,
  formattedDate,
  isNewsList = false,
  title,
  NewsDate
}: any) {
  const ImageAttr = FeaturedImage?.source?.data?.[0]?.attributes;
  const provider = NewsProvider[0]?.text;




  const GAEventsHandler = () => {
    pushToDataLayer({
      event: "card_interaction",
      cta_text: Heading,
      section_name: title || "NA",
      page_type: getGlobalStateValue('pageType'),
    });
    fireWebEngage()
  };

  const fireWebEngage=()=>{

    window.webengage.track("News Viewed", {
      "News Title":Heading,
      "Read duration":formattedDate,
      "Url":url_key,
      "Date": new Date(NewsDate)
    });
    
  }
  return (
    <a
      href={url_key || ""}
      onClick={GAEventsHandler}
      target="_blank"
      className={`block border-[0.0625rem] border-blu rounded-2xl lg:rounded-[0.833rem] ${styles.root}`}
    >
      <div
        className={cn(`flex flex-col justify-end`, styles.content, {
          [styles.contentNewsList]: isNewsList,
        })}
      >
        <img
          src={imgPathReplace(ImageAttr?.url)}
          alt={ImageAttr?.alternativeText || "News"}
          loading="lazy"
          width="20.25rem"
          height="18.125rem"
          title="News"
        />
      </div>
      <div className={`font-raleway ${styles.bottom}`}>
        <div className={`font-bold ${styles.heading}`}>
          {provider} . {formattedDate}
        </div>
        <div className={`font-semibold line-clamp-2	 ${styles.text}`}>{Heading}</div>
        <div ><img src={imgPathReplace('https://amityonline.com/_s/iconmonstr_arrow_right_circle_thin_f882a47d7c.webp')} loading="lazy"  alt='news_stories' width="2.625rem" height="2.625rem"/></div>
      </div>
    </a>
  );
}
